<template>
  <v-form ref="updatePermissionsForm" @submit.prevent="changePermissions">
    <v-card-title>
      Update Roles
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon class="ml-2" v-on="on">help</v-icon>
        </template>
        <ul>
          <li>Author: Limited Read/Write Privileges</li>
          <li>Editor: Read/Write/Edit/Publish. Limited Delete Privileges</li>
          <li>Admin: Full Privileges. User management capabilities.</li>
        </ul>
      </v-tooltip>
    </v-card-title>
    <v-card-text>
      <v-radio-group v-model="group" :disabled="disabled">
        <v-radio label="Author"
                 :value="0" />
        <v-radio label="Editor"
                 :value="1" />
        <v-radio label="Admin"
                 :value="2" />
      </v-radio-group>
    </v-card-text>
    <v-card-actions class="px-4 pb-4">
      <v-btn type="submit"
             color="primary"
             large
             ripple
             :loading="loading"
             :disabled="disabled || unchanged">Change Permissions</v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
export default {
  name: 'ChangePermissions',
  props: {
    id: String,
    roles: Array,
    disabled: Boolean,
  },
  data() {
    return {
      group: Math.max(...this.roles),
      loading: false,
    };
  },
  computed: {
    unchanged() {
      // return this.group === Math.max(...this.roles);
      return false; // Figure this out
    },
    perms() {
      return [
        ['Author'],
        ['Author', 'Editor'],
        ['Author', 'Editor', 'Admin'],
      ][this.group];
    },
  },
  methods: {
    async changePermissions() {
      try {
        this.loading = true;
        await this.$store.dispatch('post', {
          api: `User/${this.id}/Roles`,
          data: {
            Roles: this.perms,
          },
        });
        this.$emit('snackbar', 'Permissions successfully updated!');
      } catch (e) {
        // Do nothing
      }
      this.loading = false;
    },
  },
};
</script>
